import ConsoleApi from "apps/console/enums/consoleApi";
import { getApiQueryKey, useGetApiData } from "shared/datalayer";
import ContextEntityType from "shared/enums/ContextEntityType";
import { ApiFeaturedListCardConfiguration } from "shared/types/ApiFeaturedListCardConfiguration";

export function getCardConfigurationListQueryKey(id: string, contextEntityType: ContextEntityType) {
  return getApiQueryKey(ConsoleApi.GET_CARDS_CONFIG_LIST, {
    params: { id, contextEntityType }
  });
}

export function useGetCardsConfigurations(id: string, contextEntityType: ContextEntityType) {
  return useGetApiData<Array<ApiFeaturedListCardConfiguration>>(
    ConsoleApi.GET_CARDS_CONFIG_LIST,
    { params: { id, contextEntityType } },
    { enabled: Boolean(id) }
  );
}
